module.exports = __webpack_public_path__ + "img/dm_contact.91189af0.png";